import { ArrowsClockwiseIcon, CubeIcon, GearIcon, HouseIcon, CirclesThreePlus, SignInIcon, SignOutIcon, WarehouseIcon } from '@phosphor-icons/react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Sidebar() {

    const menu = [{
        label: "Dashboard",
        href: "/",
        icon: HouseIcon
    }, {
        label: "Magazzino",
        href: "/magazzino",
        icon: WarehouseIcon
    }, {
        label: "Lavorazioni",
        href: "/lavorazioni",
        icon: CirclesThreePlus
    }, {
        label: "Spostamenti",
        href: "/spostamenti",
        icon: ArrowsClockwiseIcon
    }, {
        label: "DDT in entrata",
        href: "/ingressi",
        icon: SignInIcon
    }, {
        label: "DDT in uscita",
        href: "/uscite",
        icon: SignOutIcon
    }, {
        label: "Lotti",
        href: "/lotti",
        icon: CubeIcon
    }]

    // prendo la path corrente con react router dom
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <div className='fixed top-0 left-0 bottom-0 w-[250px] bg-white rounded-r-[40px] flex flex-col'>

            <div className='w-full p-7 box-border flex justify-center items-center'>
                <p className='font-bold text-black tracking-[5px] text-xl text-center py-1 px-4 border border-black rounded-full mx-auto'>PUPA</p>
            </div>

            <div className='flex-1 w-full'>
                <ul className='w-full'>
                    {menu.map((item, index) => {
                        const Icon = item.icon;
                        let isActive = item.href !== '/' && currentPath.includes(item.href);

                        if (item.href === "/") {
                            isActive = currentPath === item.href;
                        }

                        return (
                            <li key={index} className='w-full px-3 box-border'>
                                <Link to={item.href} className={`block px-5 py-3 my-1 flex items-center gap-2 text-base font-normal rounded-[25px] hover:bg-verylight ${isActive ? 'bg-verylight text-black' : ''}`}>
                                    <Icon size={20} weight="bold" className={isActive ? 'fill-blue' : 'fill-grey'}/>
                                    {item.label}
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>

            <div className='w-full pb-5'>
                <div className='w-full px-3 box-border'>
                    <Link to="/impostazioni" className={`block px-5 py-3 my-1 flex items-center gap-2 text-base font-normal rounded-[25px] hover:bg-verylight ${currentPath.includes("/impostazioni") ? 'bg-verylight text-black' : ''}`}>
                        <GearIcon size={20} weight="bold"/>
                        Impostazioni
                    </Link>
                </div>
            </div>
        </div>
    )
}
